"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3749,5386,3903],{

/***/ 24681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ RichText; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/RichText/utils.tsx
var utils = __webpack_require__(83903);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/TiptapTextEditor.tsx + 1 modules
var TiptapTextEditor = __webpack_require__(11293);
// EXTERNAL MODULE: ./node_modules/@tiptap/react/dist/index.js + 2 modules
var dist = __webpack_require__(45823);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/ToolbarMenu.tsx + 20 modules
var ToolbarMenu = __webpack_require__(82522);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/RichText/component/TextEditor.tsx





function EditableText(param) {
    var _content = param.content, content = _content === void 0 ? "" : _content, _maxLength = param.maxLength, maxLength = _maxLength === void 0 ? undefined : _maxLength, _disabled = param.disabled, disabled = _disabled === void 0 ? true : _disabled, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TiptapTextEditor/* TiptapTextEditor */.C, {
        content: content,
        // onTextUpdate={({text}) => onChange('subHeading', text)}
        maxLength: maxLength,
        disabled: disabled,
        className: className,
        renderToolbarProps: function(editor) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* BubbleMenu */.NM, {
                editor: editor,
                tippyOptions: {
                    duration: 100
                },
                shouldShow: function(props) {
                    return props.editor.isFocused;
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "floating-menu",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarMenu/* ToolbarMenu */.H, {
                        editor: editor,
                        showFormattors: false
                    })
                })
            });
        }
    });
}

// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(46976);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/constant.ts
var constant = __webpack_require__(91074);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/utils.tsx
var Carousel_utils = __webpack_require__(58619);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(93080);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(98388);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/buttonConstant.ts
var buttonConstant = __webpack_require__(91850);
// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(62946);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/isMobileDevice.ts
var isMobileDevice = __webpack_require__(26910);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/RichTextImage/utils.tsx
var RichTextImage_utils = __webpack_require__(5386);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/RichText/component/TextWidgetSection.tsx












function TextWidgetSection(param) {
    var data = param.data, widgetOptions = param.widgetOptions, currentIndex = param.currentIndex, widgetId = param.widgetId;
    var getSubtitleSize = function getSubtitleSize() {
        switch(textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.subtitleSize){
            case buttonConstant/* BUTTON_SIZE_TYPE.SMALL */.n6.SMALL:
                return "!tw-text-[10px]";
            case buttonConstant/* BUTTON_SIZE_TYPE.MEDIUM */.n6.MEDIUM:
                return "!tw-text-[12px]";
            case buttonConstant/* BUTTON_SIZE_TYPE.LARGE */.n6.LARGE:
                return "!tw-text-[14px]";
            default:
                return "!tw-text-[10px]";
        }
    };
    var _RenderMainSection = function _RenderMainSection() {
        var ref, ref1;
        var elementsToRender = [];
        if (isStringFilled(textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.title)) {
            elementsToRender.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(EditableText, {
                content: textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.title,
                className: "tw-font-normal tw-leading-[41px]"
            }));
        }
        if (isStringFilled(textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.description)) {
            elementsToRender.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(EditableText, {
                content: textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.description,
                className: "tw-mt-[16px] tw-text-[16px] tw-font-normal tw-leading-[1.4]"
            }));
        }
        if ((textGroupItem === null || textGroupItem === void 0 ? void 0 : (ref = textGroupItem.button) === null || ref === void 0 ? void 0 : ref.length) && ((ref1 = textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.button[0]) === null || ref1 === void 0 ? void 0 : ref1.isShow)) {
            var ref2, ref3;
            elementsToRender.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mt-[28px]",
                children: (textGroupItem === null || textGroupItem === void 0 ? void 0 : (ref2 = textGroupItem.button) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-w-full",
                    style: {
                        justifyContent: constant/* TEXT_ALIGNMENT_POSITIONS */.MB === null || constant/* TEXT_ALIGNMENT_POSITIONS */.MB === void 0 ? void 0 : constant/* TEXT_ALIGNMENT_POSITIONS */.MB[isMobile ? sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.mobileAlignment : sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.alignment]
                    },
                    children: textGroupItem === null || textGroupItem === void 0 ? void 0 : (ref3 = textGroupItem.button) === null || ref3 === void 0 ? void 0 : ref3.map(function(buttonData, btnIndex) {
                        var buttonVariant = (0,Carousel_utils/* getButtonVariantsData */.Tk)(buttonData);
                        var selectedButtonType = buttonVariant[buttonData.type];
                        return buttonData.isShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            size: buttonConstant/* BUTTON_SIZE_TYPE.LARGE */.n6.LARGE,
                            btnType: buttonData.type,
                            buttonData: buttonData,
                            selectedButtonData: selectedButtonType,
                            variant: selectedButtonType.variant,
                            onClick: function() {
                                return (0,btnUtils/* btnActionHandler */.c)(buttonData === null || buttonData === void 0 ? void 0 : buttonData.actions, function() {});
                            },
                            className: (0,bundle_mjs/* twMerge */.m6)("!tw-w-auto tw-rounded-[0px]  ".concat(buttonData.type === buttonConstant/* BUTTON_TYPE.TEXTUAL */.JB.TEXTUAL ? "!tw-px-[0px]" : "!tw-px-[36px]", " !tw-pb-[12px] !tw-pt-[12px] !tw-text-[14px] !tw-font-[500] !tw-leading-[20px] tw-text-newBlack")),
                            children: buttonData === null || buttonData === void 0 ? void 0 : buttonData.text
                        }, btnIndex) : null;
                    })
                }) : null
            }));
        }
        if (!elementsToRender.length) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: elementsToRender
        });
    };
    var ref;
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = deviceType === constant/* MOBILE_DEVICE */.nD;
    var sectionConfig = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.textSection;
    var textGroupItem = data;
    var isStringFilled = function(str) {
        var ref;
        return !!((ref = str.replace("<p></p>", "")) === null || ref === void 0 ? void 0 : ref.trim());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            textAlign: constant/* TEXT_ALIGNMENT_POSITIONS */.MB === null || constant/* TEXT_ALIGNMENT_POSITIONS */.MB === void 0 ? void 0 : constant/* TEXT_ALIGNMENT_POSITIONS */.MB[isMobile ? sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.mobileAlignment : sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.alignment]
        },
        className: "tw-relative tw-flex tw-w-full tw-flex-col ".concat(isMobile ? "tw-justify-center" : "tw-justify-".concat(sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.position)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,bundle_mjs/* twMerge */.m6)("tw-relative tw-flex tw-flex-col", (textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.subtitlePosition) === "bottom" ? "tw-flex-col-reverse" : " tw-gap-[12px]"),
            children: [
                isStringFilled(textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.subtitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EditableText, {
                    content: textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.subtitle,
                    className: (0,bundle_mjs/* twMerge */.m6)("tw-font-normal tw-leading-[20px]", getSubtitleSize(), "".concat((textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.subtitlePosition) === "bottom" && ((ref = textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.button[0]) === null || ref === void 0 ? void 0 : ref.isShow) ? "tw-mt-[24px]" : ""))
                }) : null,
                _RenderMainSection()
            ]
        })
    });
}
function TextWidgetContainer(param) {
    var widgetOptions = param.widgetOptions, widgetId = param.widgetId;
    var getTextContainerStyle = function getTextContainerStyle() {
        var selectedColorDetails = (0,RichTextImage_utils.getTextAndBackgroundColor)(widgetOptions);
        return {
            width: isMobile ? "" : (baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.makeFullWidth) ? "100%" : "calc(70% + 95px)",
            color: selectedColorDetails.text
        };
    };
    var ref, ref1;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var baseConfig = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.baseConfig;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: getTextContainerStyle(),
        className: "tw-relative tw-w-full\n       ".concat(isMobile ? "tw-justify-center" : "tw-flex tw-flex-col", "\n       ").concat((baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.makeFullWidth) ? "tw-max-w-[1000px]" : "", " \n       "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-flex tw-w-[100%] tw-flex-col",
            children: widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref = widgetOptions.textGroupSection) === null || ref === void 0 ? void 0 : (ref1 = ref.groupItemsList) === null || ref1 === void 0 ? void 0 : ref1.map(function(data, index) {
                if (data.isVisible === false) {
                    return null;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWidgetSection, {
                    data: data,
                    widgetOptions: widgetOptions,
                    currentIndex: 0,
                    widgetId: widgetId
                }, index);
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/RichText/index.tsx








var RichTextWidget = function(props) {
    var ref;
    var widgetContextState = (0,WidgetDndContext/* useWidgetDndContextData */.KX)().widgetContextState;
    var widgets = widgetContextState.widgets, activeWidgetId = widgetContextState.activeWidgetId;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var activeWidget = widgets[props.id];
    var activeWidgetProps = activeWidget === null || activeWidget === void 0 ? void 0 : activeWidget.props;
    var widgetOptions = (0,_object_spread/* default */.Z)({}, utils.RICH_TEXT_DEFAULT_WIDGET_OPTIONS, props.widgetOptions, activeWidgetProps);
    var getStyleObject = function() {
        var ref;
        var baseConfig = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.baseConfig;
        var sectionConfig = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.textSection;
        var selectedColorDetails = (0,RichTextImage_utils.getTextAndBackgroundColor)(widgetOptions);
        var ref1, ref2;
        var style = {
            justifyContent: isMobile ? "" : sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.position,
            width: (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref = widgetOptions.baseConfig) === null || ref === void 0 ? void 0 : ref.makeFullWidth) ? "100%" : "90%",
            margin: "0 auto",
            padding: isMobile ? "".concat((ref1 = baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.paddingMobileY) !== null && ref1 !== void 0 ? ref1 : 0, "px 28px") : "".concat((ref2 = baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.paddingDesktopY) !== null && ref2 !== void 0 ? ref2 : 0, "px 68px"),
            marginTop: baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.marginTop,
            marginBottom: baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.marginBottom,
            border: (baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.showBorder) ? "".concat(baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.borderThicness, "px solid ").concat(baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.borderColor) : "",
            background: selectedColorDetails.background
        };
        return style;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.isVisible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: getStyleObject(),
            className: "".concat(!(widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref = widgetOptions.baseConfig) === null || ref === void 0 ? void 0 : ref.makeFullWidth) ? "tw-max-w-[1500px]" : "", " tw-w-[100%] ").concat(isMobile ? "tw-px-[28px]" : "tw-px-[68px]", " tw-flex"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWidgetContainer, {
                widgetOptions: widgetOptions,
                widgetId: activeWidgetId
            })
        }) : null
    });
};
/* harmony default export */ var RichText = (RichTextWidget);


/***/ }),

/***/ 83903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BASE_SECTION_BACKGROUND_TYPES": function() { return /* binding */ BASE_SECTION_BACKGROUND_TYPES; },
/* harmony export */   "RICH_TEXT_DEFAULT_WIDGET_OPTIONS": function() { return /* binding */ RICH_TEXT_DEFAULT_WIDGET_OPTIONS; },
/* harmony export */   "RICH_TEXT_KEY": function() { return /* binding */ RICH_TEXT_KEY; },
/* harmony export */   "SUBTITLE_POSITIONS_DATA": function() { return /* binding */ SUBTITLE_POSITIONS_DATA; },
/* harmony export */   "SUBTITLE_SIZE_LIST": function() { return /* binding */ SUBTITLE_SIZE_LIST; },
/* harmony export */   "TEXT_GROUP_OPTIONS_ITEM": function() { return /* binding */ TEXT_GROUP_OPTIONS_ITEM; }
/* harmony export */ });
/* harmony import */ var _components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37179);

var BASE_SECTION_BACKGROUND_TYPES = {
    color: "color",
    image: "image"
};
var SUBTITLE_POSITIONS_DATA = [
    {
        text: "Top",
        value: "top",
        itemLevelClass: "tw-w-[50%]"
    },
    {
        text: "Bottom",
        value: "bottom",
        itemLevelClass: "tw-w-[50%]"
    }, 
];
var SUBTITLE_SIZE_LIST = [
    {
        text: "Small",
        value: "small"
    },
    {
        text: "Medium",
        value: "medium"
    },
    {
        text: "Large",
        value: "large"
    }, 
];
var TEXT_GROUP_OPTIONS_ITEM = {
    title: "<h2>Talk about your brand</h2>",
    subtitleSize: "small",
    isVisible: true,
    subtitlePosition: "top",
    subtitle: "<p>Subtitle</p>",
    description: "<p>Use this text to share information about your brand with your customers.\n   Describe a product, share announcements, or welcome customers to your store.</p>",
    button: [
        (0,_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultConfig */ ._K)("bannerButton", "#000000", "#FFFFFF")
    ]
};
var RICH_TEXT_KEY = {
    ALIGNMENT: "alignment",
    POSITION: "position",
    MOBILE_ALIGNMENT: "mobileAlignment",
    BACKGROUND_COLOR: "backgroundColor",
    TEXT_COLOR: "textColor",
    BACKGROUND: "background",
    BORDER_COLOR: "borderColor",
    SHOW_BORDER: "showBorder",
    MAKE_FULL_WIDTH: "makeFullWidth"
};
var RICH_TEXT_DEFAULT_WIDGET_OPTIONS = {
    isVisible: true,
    baseConfig: {
        background: "#ffffff",
        foregroundImage: "",
        paddingDesktopY: 70,
        paddingMobileY: 70,
        marginTop: 0,
        marginBottom: 0,
        bgImage: {
            url: "",
            src: "",
            opacity: 70
        },
        backgroundType: BASE_SECTION_BACKGROUND_TYPES.color,
        showBorder: false,
        makeFullWidth: true,
        borderColor: "#e2e4e7",
        borderThicness: 1
    },
    textSection: {
        backgroundColors: [
            {
                background: "#ffffff",
                text: "#000000",
                isDefault: false
            },
            {
                background: "transparent",
                text: "#ffffff",
                isDefault: false
            }, 
        ],
        bgFillType: BASE_SECTION_BACKGROUND_TYPES.color,
        bgImage: {
            url: "",
            src: "",
            opacity: 70
        },
        selectedIndex: 0,
        textColor: "#000000",
        backgroundColor: "#ffffff",
        position: "center",
        alignment: "left",
        mobileAlignment: "left"
    },
    textGroupSection: {
        builderConfig: {
            textSection: {
                subtitlePositions: SUBTITLE_POSITIONS_DATA,
                subtitleSize: SUBTITLE_SIZE_LIST
            }
        },
        groupItemsList: [
            TEXT_GROUP_OPTIONS_ITEM
        ]
    }
};


/***/ }),

/***/ 5386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BASE_SECTION_BACKGROUND_TYPES": function() { return /* binding */ BASE_SECTION_BACKGROUND_TYPES; },
/* harmony export */   "HEIGHT_ACC_IMAGE_TYPE_1": function() { return /* binding */ HEIGHT_ACC_IMAGE_TYPE_1; },
/* harmony export */   "HEIGHT_ACC_IMAGE_TYPE_2": function() { return /* binding */ HEIGHT_ACC_IMAGE_TYPE_2; },
/* harmony export */   "OVERLAP_TYPE": function() { return /* binding */ OVERLAP_TYPE; },
/* harmony export */   "RICH_IMAGE_TEXT_DEFAULT_WIDGET_OPTIONS": function() { return /* binding */ RICH_IMAGE_TEXT_DEFAULT_WIDGET_OPTIONS; },
/* harmony export */   "SUBTITLE_POSITIONS_DATA": function() { return /* binding */ SUBTITLE_POSITIONS_DATA; },
/* harmony export */   "SUBTITLE_SIZE_LIST": function() { return /* binding */ SUBTITLE_SIZE_LIST; },
/* harmony export */   "TEXT_GROUP_OPTIONS_ITEM": function() { return /* binding */ TEXT_GROUP_OPTIONS_ITEM; },
/* harmony export */   "getTextAndBackgroundColor": function() { return /* binding */ getTextAndBackgroundColor; }
/* harmony export */ });
/* harmony import */ var _components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37179);

var BASE_SECTION_BACKGROUND_TYPES = {
    color: "color",
    image: "image"
};
var SUBTITLE_POSITIONS_DATA = [
    {
        text: "Top",
        value: "top",
        itemLevelClass: "tw-w-[50%]"
    },
    {
        text: "Bottom",
        value: "bottom",
        itemLevelClass: "tw-w-[50%]"
    }, 
];
var SUBTITLE_SIZE_LIST = [
    {
        text: "Small",
        value: "small"
    },
    {
        text: "Medium",
        value: "medium"
    },
    {
        text: "Large",
        value: "large"
    }, 
];
var TEXT_GROUP_OPTIONS_ITEM = {
    title: "<h2>Title</h2>",
    subtitleSize: "small",
    isVisible: true,
    subtitlePosition: "top",
    subtitle: "<p>Subtitle</p>",
    description: "<p>Pair text with an image to focus on your\n  chosen product, collection, or blog post.\n  Add details on availability, style, or even\n  provide a review.</p>",
    button: [
        (0,_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultConfig */ ._K)("bannerButton", "#000000", "#FFFFFF")
    ]
};
// This signifies whether the image overlaps the text box or not
var OVERLAP_TYPE = {
    OVERLAP: "overlap",
    NO_OVERLAP: "noOverlap"
};
var RICH_IMAGE_TEXT_DEFAULT_WIDGET_OPTIONS = {
    isVisible: true,
    baseConfig: {
        background: "#ffffff",
        foregroundImage: "",
        paddingY: 0,
        paddingX: 0,
        paddingMobileX: 0,
        marginTop: 0,
        marginBottom: 0,
        bgImage: {
            url: "",
            src: "",
            opacity: 70
        },
        backgroundType: BASE_SECTION_BACKGROUND_TYPES.color,
        overlapType: OVERLAP_TYPE.NO_OVERLAP,
        showBorder: false
    },
    textSection: {
        backgroundColors: [
            {
                background: "#ffffff",
                text: "#000000",
                isDefault: false
            },
            {
                background: "transparent",
                text: "#ffffff",
                isDefault: false
            }, 
        ],
        bgFillType: BASE_SECTION_BACKGROUND_TYPES.color,
        bgImage: {
            url: "",
            src: "",
            opacity: 70
        },
        selectedIndex: 0,
        textColor: "#000000",
        backgroundColor: "#ffffff",
        position: "center",
        alignment: "left",
        mobileAlignment: "left"
    },
    imageSection: {
        url: "",
        src: "",
        desktop: {
            width: "50%",
            height: "450px",
            imageAlignment: "left"
        },
        mobile: {
            width: "50%",
            height: "350px",
            mobileHeight: "350px",
            imageAlignment: "top"
        },
        animationType: "zoomIn"
    },
    textGroupSection: {
        builderConfig: {
            textSection: {
                subtitlePositions: SUBTITLE_POSITIONS_DATA,
                subtitleSize: SUBTITLE_SIZE_LIST
            }
        },
        groupItemsList: [
            TEXT_GROUP_OPTIONS_ITEM
        ]
    }
};
var HEIGHT_ACC_IMAGE_TYPE_1 = {
    top: "0px",
    middle: "75px",
    bottom: "150px"
};
var HEIGHT_ACC_IMAGE_TYPE_2 = {
    top: "0px",
    middle: "150px",
    bottom: "300px"
};
function getTextAndBackgroundColor(widgetOptions) {
    var ref, ref1;
    var selectedBgIndex = widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref = widgetOptions.textSection) === null || ref === void 0 ? void 0 : ref.selectedIndex;
    var selectedColorDetails = widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref1 = widgetOptions.textSection) === null || ref1 === void 0 ? void 0 : ref1.backgroundColors[selectedBgIndex];
    return selectedColorDetails;
}


/***/ })

}]);